/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { SwimlanesComponent } from './swimlanes/swimlanes.component';
import { SwimlaneComponent } from './swimlanes/swimlane.component';
import { CompletedSelectionPromptComponent } from './completed-selection-prompt/completed-selection-prompt.component';

import { CrewSizesComponent } from 'src/app/modules/plan/crew-sizes/crew-sizes.component';
import { ColorPickerModule } from 'src/app/common/color-picker/color-picker.module';
import { MultiSelectMenuComponent } from './multi-select-menu/multi-select-menu.component';
import { ClipboardInDockComponent } from './clipboard-in-dock/clipboard-in-dock.component';
import { CycleTicketsComponent } from './cycle-tickets/cycle-tickets.component';
import { UtilityComponentsModule } from 'src/app/common/utility-components/utility-components.module';

import { PlanUndosService } from './plan-undos.service';
import { MoveActiveLinePopupComponent } from './clipboard-in-dock/move-active-line-popup/move-active-line-popup.component';
import { PasteModesInfoPopupComponent } from './clipboard-in-dock/paste-modes-info-popup/paste-modes-info-popup.component';
import { TicketEditLocationsComponent } from './ticket-edit-locations/ticket-edit-locations.component';
import { MaterialModule } from 'src/app/common/material/material-module';
import { DialogReusableModule } from 'src/app/common/dialog-reusable/dialog-reusable.module';
import { PresentationModule } from 'src/app/common/presentation-components/presentation.module';
import { ReportsModule } from '../reports/reports.module';
import { ProjectDialogsModule } from 'src/app/common/project-dialogs/project-dialogs.module';
// BEGIN PLACEHOLDER REPLACE AS PART OF TP-5099
// Consider moving this out of plan module
// END PLACEHOLDER REPLACE AS PART OF TP-5099
import { TicketHoverContentsComponent } from './ticket-hover-contents/ticket-hover-contents.component';

//the angular base
@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		ColorPickerModule,
		UtilityComponentsModule,
		FormsModule,
		MaterialModule,
		DialogReusableModule,
		PresentationModule,
		ReportsModule,
		ProjectDialogsModule,
	],
	declarations: [
		SwimlanesComponent,
		SwimlaneComponent,
		CompletedSelectionPromptComponent,
		CrewSizesComponent,
		MultiSelectMenuComponent,
		ClipboardInDockComponent,
		MoveActiveLinePopupComponent,
		PasteModesInfoPopupComponent,
		CycleTicketsComponent,
		TicketEditLocationsComponent,
		TicketHoverContentsComponent,
	],
	exports: [
		SwimlanesComponent,
		SwimlaneComponent,
		CompletedSelectionPromptComponent,
		CrewSizesComponent,
		MultiSelectMenuComponent,
		ClipboardInDockComponent,
		MoveActiveLinePopupComponent,
		PasteModesInfoPopupComponent,
		CycleTicketsComponent,
		TicketHoverContentsComponent,
	],
	providers: [PlanUndosService],
})
export class PlanModule {}
